<template>
    <center>
        <mini-gauge v-if="ttOptionInterface.es=='E' && ttOptionInterface.idUnite && ttOptionInterface.idUnite!='BOOLEAN'" :libelle="ttOptionInterface.libOptionInterface"
        :unite="ttOptionInterface.idUnite | symboleUnite" 
        :valeur="parseFloat(ttOptionInterface.valeur)" :min="parseFloat(ttOptionInterface.min)" :max="parseFloat(ttOptionInterface.max)" ></mini-gauge>

        <span class="tag is-light" v-if="ttOptionInterface.es=='E' && ttOptionInterface.idUnite=='BOOLEAN' 
          && ttOptionInterface.valeur=='0'">{{ttOptionInterface.libOptionInterface}}</span>

        <span class="tag is-info" v-if="ttOptionInterface.es=='E' && ttOptionInterface.idUnite=='BOOLEAN' 
          && ttOptionInterface.valeur=='1'">{{ttOptionInterface.libOptionInterface}}</span>

        <a class="button is-fullwidth" @click="executerOptionAvecNotification(ttOptionInterface.defaut)" v-if="ttOptionInterface.es=='S' && ttOptionInterface.idUnite == undefined" >
          <span class="icon">
            <i class="far fa-play-circle"></i>
          </span>
          <span>{{ttOptionInterface.libOptionInterface}}</span>
        </a>

        <div class="field has-addons"  style="margin: 0px;" v-if="ttOptionInterface.es=='S' && ttOptionInterface.idUnite && ttOptionInterface.idUnite!='POURCENT'">
          <p class="control is-expanded" style="margin: 0px;">
            <button class="button is-fullwidth" @click="executerOptionAvecNotification(ttOptionInterface.defaut)">
              <span class="icon is-small">
                <i class="far fa-play-circle"></i>
              </span>
              <span>{{ttOptionInterface.libOptionInterface}}</span>
            </button>
          </p>
          <p class="control"  style="margin: 0px;">
            <button class="button" @click="ouvrirParametre">
              <span class="icon is-small">
                <i class="fas fa-cog"></i>
              </span>
            </button>
          </p>
        </div>

        <div class="modal" v-bind:class="{ 'is-active': EditerParametre }">
            <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <span class="icon is-large">
                            <i class="fas fa-lg fa-bolt"></i>
                        </span>
                        <!-- Libellé régle -->
                        <div class="field">
                            <label class="label">{{ ttOptionInterface.libOptionInterface }}</label>
                        </div>
                    </header>
                    <section class="modal-card-body">
                      <div class="field is-horizontal">
                        <div class="field-label">
                          <label class="label">{{ttOptionInterface.description}} ({{ ttOptionInterface.idUnite | symboleUnite }})</label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <p class="control">
                              <input class="input" type="text" :placeholder="ttOptionInterface.defaut" v-model="valeur">
                            </p>
                          </div>
                        </div>
                      </div>
                    </section>
                    <footer class="modal-card-foot">
                        <a class="button is-success" @click="executerOptionAvecNotification(valeur);fermerParametre()">
                            <span class="icon is-small">
                                <i class="fas fa-check"></i>
                            </span>
                            <span>Envoyer</span>
                        </a>
                    </footer>
                </div>
            <button class="modal-close is-large" aria-label="close" @click="fermerParametre"></button>
        </div>

        <div class="content" v-if="ttOptionInterface.es=='S' && ttOptionInterface.idUnite=='POURCENT' && ttOptionInterface.defaut==''" >
          <span>{{ttOptionInterface.libOptionInterface}}</span>
          <vue-slider v-model="valeur" :interval="1" :min="parseInt(ttOptionInterface.min)" :max="parseInt(ttOptionInterface.max)" @change="executerOptionSansNotification(valeur)"></vue-slider>
        </div>
    </center>
</template>

<script>
import UniteSymboleFilter from '../filters/uniteFilter'
import MiniGauge from '../components/MiniGauge'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  props : [
    'ttOptionInterface'
  ],
  components: {
    'mini-gauge': MiniGauge,
    'vue-slider': VueSlider
  },
  data() {
    return {
      valeur: '',
      EditerParametre: false
    }
  },
  methods: {
    executerOption(valeur) {
      let optionInterface = {
        idOptionInterface: this.ttOptionInterface.idOptionInterface,
        valeur: valeur
      }
      return this.$store.dispatch('executerOption', optionInterface)
    },
    executerOptionAvecNotification(valeur) {
      this.executerOption(valeur)
      .then(() => {
        this.$notify({
          group: 'global',
          type: 'success',
          title: this.ttOptionInterface.libOptionInterface + ' exécutée',
        })
      })
      .catch((error) => {
        this.$notify({
          group: 'global',
          type: 'error',
          title: 'Erreur lors de l\'exécution de ' + this.ttOptionInterface.libOptionInterface,
          text: error.response.data.libellesMessages
        })
      });
    },
    executerOptionSansNotification(valeur) {
      this.executerOption(valeur)
    },
    ouvrirParametre() {
      this.EditerParametre = true
    },
    fermerParametre() {
      this.EditerParametre = false
    }
  },
  filters: {
    symboleUnite: UniteSymboleFilter.symbole
  }
}
</script>

<style scoped>
.button, .boolean, .tag {
    text-align: left;
    margin-bottom: 5px;
}
</style>
